import { styled } from '@withjoy/joykit';

export const ReimagineWrapper = styled.div<{ position: number; index: number; spacing: number }>`
  transition: transform 500ms cubic-bezier(0.075, 0.82, 0.165, 1);
  transform: translateX(calc(${props => (props.position - props.index) * props.spacing}px));
  opacity: ${props => (props.position != props.index ? '0' : '1')};
`;
